
import { ref, computed, defineComponent, nextTick } from "vue-demi";
import { SMDocumentsV2 } from "@/store";
import axios from "@/plugins/http";
import { API_ROUTES } from "@/utils/API";

export default defineComponent({
  name: "DocumentActionContainerCard",

  components: {
    PDFViewer: () => import("@/modules/Documents/PDFViewer.vue"),
  },

  props: {
    examplePath: {
      type: String,
      default: "",
    },
    documentTemplateId: {
      type: Number,
      required: true,
    },
  },

  setup(props, { slots }) {
    const hasSlot = (slotName: string) => !!slots[slotName];

    const pdfViewerKey = ref(0);

    const pdfViewerLink = ref("");

    const pdfViewerName = ref("");

    const isPdfViewerOpen = ref(false);

    function togglePdfViewer(value: boolean) {
      isPdfViewerOpen.value = value;
    }

    async function viewExample() {
      if (!props.documentTemplateId) return console.log("no documentTemplateId");

      try {
        const response = await axios.get<ArrayBuffer>(
          API_ROUTES.DOCUMENTS_EXAMPLE(props.documentTemplateId),
          {
            responseType: "arraybuffer",
          }
        );

        const { data } = response;

        if (!data) return;

        const contentDisposition = response.headers["content-disposition"];

        pdfViewerLink.value = await SMDocumentsV2.createFileLink(data);

        pdfViewerName.value = await SMDocumentsV2.getFileNameContentDisposition(contentDisposition);

        pdfViewerKey.value += 1;

        await nextTick();

        togglePdfViewer(true);
      } catch (e) {
        console.log("failed to view example:", e);
      }
    }

    return {
      hasDescriptionSlot: computed(() => hasSlot("description")),
      pdfViewerKey,
      pdfViewerLink,
      pdfViewerName,
      isPdfViewerOpen,
      togglePdfViewer,
      viewExample,
    };
  },
});
